/**
 * What clients and other contexts read of CDN, safe for every bundle: the
 * wire shape of the playback token row (`user.getCDNKey`), the rule that
 * signs a media URL with it and the public song preview URL. The other subpaths:
 * `@libs/cdn-contracts/signing` (`CdnUrlSigner`, the Bunny signer's port,
 * which `@libs/cdn-server/signing` implements) and
 * `@libs/cdn-contracts/events` (the Inngest event that asks for new tokens).
 */
export { cdnKeyWireSchema, type CDNKey } from "./cdn-key";
export { signUrl, type CdnKeyTokens } from "./sign-url";
export { publicSongPreviewUrl } from "./public-preview-url";
